import { rootSelector } from '@/redux/root/root.selectors';
import { createSelector } from '@reduxjs/toolkit';
import { CommentWithPinType } from '@/types/comment';
import { currentModelIdSelector } from '../models/models.selectors';

export const commentSelector = createSelector(rootSelector, state => state.comment);

export const commentReactionSelector = createSelector(
  commentSelector,
  commentState => commentState.commentReaction,
);

export const allCommentsSelectorOfCurrentMap = createSelector(
  commentSelector,
  currentModelIdSelector,
  (commentState, currentModelId): CommentWithPinType[] => {
    if (!commentState) {
      return [];
    }

    return (commentState.data || [])
      .filter(comment => comment.map === currentModelId && !comment.deleted)
      .map(comment => {
        return {
          ...comment,
          pinType: 'comment',
        };
      });
  },
);

// Admin selectors
export const selectAllProjectComments = createSelector(
  commentSelector,
  commentState => commentState.data || [],
);

export const selectCommentsLoading = createSelector(
  commentSelector,
  commentState => commentState.loading,
);
